import { createApp } from 'vue'

import route from '@user-plugins/routes/index.js'
import vuetify from '@user-plugins/vuetify/index.js'
import store from '@user-plugins/store/index.js'

import App from '@user-components/App.vue'

createApp(App).use(route).use(vuetify).use(store).mount("#app")